import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapState } from 'vuex';
import Vue from 'vue';

function hasSameKey(obj1, obj2) {
  for (var key in obj1) {
    if (typeof obj2[key] !== 'undefined') {
      return true;
    }
  }

  return false;
}

export function mixinBaseComputed() {
  var baseMixinPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var stateArr = ['userInfo', 'payVip', 'isLogin', 'isInit', 'initPromise'];
  var options = {};

  for (var _i = 0, _stateArr = stateArr; _i < _stateArr.length; _i++) {
    var key = _stateArr[_i];
    options[baseMixinPrefix + key] = key;
  }

  options[baseMixinPrefix + 'isVip'] = function (state) {
    return !!state.payVip && !!state.payVip.vip;
  };

  var baseComputed = mapState(options);
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var propsConflict = this.$options.props && hasSameKey(this.$options.props, baseComputed);
      var computedConflict = this.$options.computed && hasSameKey(this.$options.computed, baseComputed);

      if (!propsConflict && !computedConflict) {
        if (typeof this.$options.computed === 'undefined') {
          this.$options.computed = {};
        }

        this.$options.computed = _objectSpread(_objectSpread({}, this.$options.computed), baseComputed);
      }
    }
  });
}